import { render, staticRenderFns } from "./DynPropDateDetail.vue?vue&type=template&id=fda3a344"
import script from "./DynPropDateDetail.vue?vue&type=script&lang=js"
export * from "./DynPropDateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports